import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import get from 'lodash.get';
import { useEffect, useState } from 'react';
import { PAGE_SIZE } from '~/modules/common/const';

const ENABLED_BILLING_RATES_QUERY = gql`
  query getEnabledBillingRates(
    $projectId: String!
    $page: Int!
    $pageSize: Int!
    $textSearch: String
  ) {
    enabledBillingRates(
      projectId: $projectId
      page: $page
      pageSize: $pageSize
      textSearch: $textSearch
    ) {
      id
      displayText
    }
  }
`;

export const useEnabledBillingRates = ({
  page = 1,
  pageSize = PAGE_SIZE,
  projectId,
  textSearch = null,
  skip = false
}) => {
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(textSearch);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(textSearch);
    }, 300);

    return () => clearTimeout(timer);
  }, [textSearch]);

  const { data, loading } = useQuery(ENABLED_BILLING_RATES_QUERY, {
    variables: {
      projectId,
      page,
      pageSize,
      textSearch: debouncedSearchTerm || undefined
    },
    skip,
    fetchPolicy: 'network-only'
  });

  const billingRates = get(data, 'enabledBillingRates', []);

  return {
    loading,
    billingRates
  };
};

export default useEnabledBillingRates;
